import { IDataset } from '@talxis/client-libraries';
import { AggregationButtonPlacementTypes } from './components/View/View';
import { LegacyGrid } from './LegacyGrid';
import { Grid } from './Grid';

// Define IInputs and IOutputs Type. They should match with ControlManifest.
export interface IInputs {
    Columns: ComponentFramework.PropertyTypes.StringProperty;
    Height: ComponentFramework.PropertyTypes.StringProperty;
    RowHeight: ComponentFramework.PropertyTypes.WholeNumberProperty;
    EnableEditing: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnablePagination: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableFiltering: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableSorting: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableNavigation: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableOptionSetColors: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableAggregation: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnableAutoSave: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    SelectableRows: ComponentFramework.PropertyTypes.EnumProperty<"none" | "single" | "multiple">;
    HomePageGridClientApiRibbonButtonId: ComponentFramework.PropertyTypes.StringProperty;
    InlineRibbonButtonIds: ComponentFramework.PropertyTypes.StringProperty;
    Grid: ComponentFramework.PropertyTypes.DataSet;
    RibbonGroupingDataset: ComponentFramework.PropertyTypes.DataSet;
    EnableChangeEditor: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    EnablePageSizeSwitcher: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    DisableNewGrid: ComponentFramework.PropertyTypes.EnumProperty<"true" | "false">;
    IsViewPage: ComponentFramework.PropertyTypes.StringProperty;
    TargetEntityType: ComponentFramework.PropertyTypes.StringProperty; //legacy grid
    EnableGroupBy: ComponentFramework.PropertyTypes.StringProperty; //legacy grid
    AggregateObjectArray: ComponentFramework.PropertyTypes.StringProperty; //legacy grid
    GroupByAttributes: ComponentFramework.PropertyTypes.StringProperty; //legacy grid
    AggregationButtonPlacement: ComponentFramework.PropertyTypes.EnumProperty<AggregationButtonPlacementTypes>; //legacy grid
}

export interface IOutputs {
}

export class View implements ComponentFramework.StandardControl<IInputs, IOutputs> {
    private _controlInstance: ComponentFramework.StandardControl<IInputs, IOutputs>
    constructor(isLegacy?: boolean) {
        if (isLegacy) {
            this._controlInstance = new LegacyGrid();
        }
        else {
            this._controlInstance = new Grid();
        }
    }

    /**
     * Used to initialize the control instance.
     * @param context The entire property bag available to control via Context Object.
     * @param notifyOutputChanged A callback method to alert the framework that the control has new outputs.
     * @param state A piece of data that persists in one session for a single user.
     * @param container The div element within which the control can render its content.
     */
    public init(context: ComponentFramework.Context<IInputs, IOutputs>, notifyOutputChanged: () => void, state: ComponentFramework.Dictionary, container: HTMLDivElement): void {
        this._controlInstance.init(<any>context, notifyOutputChanged, state, container);
    }

    /**
     * Called when any value in the property bag has changed.
     * @param context The entire property bag available to control via Context Object.
     */
    public updateView(context: ComponentFramework.Context<IInputs, IOutputs>): void {
        this._controlInstance.updateView(<any>context);
    }

    /**
     * Called to retrieve the output values from the control.
     * @returns The output object containing the dataset control.
     */
    public getOutputs(): IOutputs {
        return this._controlInstance.getOutputs();
    }

    /**
     * Called when the control is to be removed from the DOM.
     */
    public destroy(): void {
        this._controlInstance.destroy();
    }
}